export default {
  applyTrial: {
    freeTrial: '無料トライアル',
    dialog: {
      title: 'トライアルを申し込む',
      forbiden: '権限なし',
      desc: 'サービスをより良く提供するために、トライアルサービスを開始する前に以下をお知らせください:',
      cancel: 'キャンセル',
      applyApproved: '申請が承認されました',
      form: {
        pleaseInput: '入力してください',
        empty: '必須項目です',
        atleast: '少なくとも一つの選択肢',
        urlValidator: {
          errorInfo: 'URLの形式が無効です',
        },
        full_name: {
          label: '連絡先名',
        },
        phone: {
          label: '連絡先電話',
        },
        region: {
          label: '国または地域',
        },
        company: {
          label: '会社',
        },
        company_type: {
          label: '会社の種類',
        },
        job_title: {
          label: '役職',
        },
        product_type: {
          label: 'プロモーション製品の種類',
        },
        app_url: {
          label: '主な製品ストアのリンク',
          placeholder: '製品リンク',
        },
        contact_account: {
          label: '連絡先情報およびアカウント',
        },
        team_size: {
          label: 'クリエイティブチームの規模',
        },
        isMtg: {
          label: 'Mintegralの利用実績はありますか？',
        },
        interested_in: {
          label: '興味のある機能',
        },
        mtg_name: 'Mintegral ユーザネーム',
        interesting_gameplay: {
          label: '興味のあるクリエイティブの種類',
        },
        interesting_videos: {
          label: '興味のあるビデオ機能',
        },
        message: {
          label: '素材制作において期待する効果を説明してください',
        },
      },
    },
    trialSuccess: {
      tips: 'Playturbo のトライアルが開始されました。有効期間は {days} 日間です（満了日：{expired_date}）。早速、あなたのクリエイティブな制作の旅を始めましょう！',
      message: 'トライアルの有効化に成功しました',
      ok: '確認',
    },
    form: {
      companyType: {
        band: 'ブランドオーナー',
        agent: '広告代理店',
        media: 'パブリッシャー',
        game: 'ゲーム',
        app: 'APP',
        adv: '広告主',
        dev: 'デベロッパー',
        other: 'その他',
      },
      connectType: {
        wechat: 'WeChat',
        skype: 'Skype',
        slack: 'Slack',
        telegram: 'Telegram',
      },
      willFeature: {
        pl: 'プレイアブル広告制作のみ',
        video: '動画広告制作のみ',
        plvideo: 'プレイアブル+ビデオ広告制作',
      },
      willVideo: {
        crossover: 'ビデオクリップ編集',
        mlang: 'ビデオ多言語制作',
        mtsize: 'ビデオ複数サイズ制作',
        ai: 'ビデオAI削除',
      },
      ismtg: {
        yes: 'はい',
        no: 'いいえ',
      },
      productType: {
        casual: 'カジュアル',
        hypercasual: 'ハイパーカジュアル',
        mid: 'ミッドコア・ハードコア',
        casino: 'ギャンブル・ベッティング',
        playtoearn: 'ポイ活',
        entertainment: 'エンターテインメント',
        social: 'ソーシャル',
        utility: 'ツール',
        education: '教育',
        finance: '金融',
        travel: '旅行',
        ecommerce: 'EC',
      },
    },
  },
  totop: {
    contact: {
      title: 'お問い合わせ',
      desc: 'ご不明な点がございましたら、こちらにメッセージを残し、連絡先とアカウント情報をご記入ください。<br/>または <a href="mailto:playturbo@mindworks-creative.com">playturbo@mindworks-creative.com</a> までメールでご連絡ください。<br/>メッセージを受け取り次第、できるだけ早くご連絡いたします！',
      dialog: {
        input: {
          placeholder: '問題の内容を説明してください',
        },
        cancel: 'キャンセル',
        submit: '送信',
        success: 'メッセージが送信されました',
      },
    },
    QRCode: {
      title: 'WeChatでスキャンしてカスタマーサポートにお問い合わせください',
    },
  },
}
